import {
	ALL_APPS_LOADING,
	ALL_APPS_GET,
	ALL_APPS_ERROR
} from '../actions/types';

const initialState = {
	all_apps_loading: false,
	all_apps: [],
	apps_errors: {}
}

export default function appReducer(state = initialState, action) {
	switch (action.type) {
		case ALL_APPS_LOADING:
			return {
				...state,
				all_apps_loading: action.payload
			}
		case ALL_APPS_GET:
			delete state.apps_errors.all_apps
			return {
				...state,
				all_apps: action.payload
			}
		case ALL_APPS_ERROR:
			return {
				...state,
				apps_errors: {
					...state.apps_errors, 
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
